import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";


export const noteApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchNotes: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-all-note-logics?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['notes'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getNoteById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-note-logic-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['noteById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createNoteLogic: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/note-logic`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['notes'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Note");
            },
        }),
        updateNote: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update/note-logic/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['notes', 'noteById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","Note")
            },
        }),

        deleteNoteById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete/note-logic/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['notes'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Note");
            },
        }),

    }),
});


export const {
    useSearchNotesQuery,
    useGetNoteByIdQuery,
    useCreateNoteLogicMutation,
    useUpdateNoteMutation,
    useDeleteNoteByIdMutation,
} = noteApi;